// removed by extract-text-webpack-plugin
module.exports = {"wrap":"wrap__2XmJq","standfirst":"standfirst__1N0uk","magnetic":"magnetic__3BBYz","magnetCenter":"magnetCenter__27CVO","onRight":"onRight__2RCJW","section1":"section1__rDAb7","section2":"section2__29Dir","section3":"section3__29eb1","section4":"section4__VUpMp","section5":"section5__1TfZO"};


//////////////////
// WEBPACK FOOTER
// ./components/Chapter/style.css
// module id = 82uG
// module chunks = 0